import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


export interface EnumViewModelWithInfo {
    name?: null | string;
    value?: number | string | null;
    info?: null | string;
    tabName?: null | string; //for tabbed selects
}

export class AddItemDialogData {
    title: string;
    items: AddItemData[];
    buttons: AddButtonData[];
  }

export class AddItemData {
    name: string;
    type?: string; //null, date, textarea, currency, percentage, select, quill, radio, radioMulti, iconSelect
    mandatory?: boolean;
    propertyName?: string;
    icon?: string;
    initialValue?: string;
    currencyValue: number;
    options?: EnumViewModelWithInfo[]; //for select and radio types only
    colSpan?: number;
    hasTabs?: boolean; //for radio/radioMulti - split lists into tabs by item tabName
}

export class AddButtonData {
    name: string;
    closeDialog: boolean;
    callback: () => void;
}

@Component({
    selector       : 'add-item-dialog',
    templateUrl    : './add-item-dialog.component.html'
})
export class AddItemDialogComponent implements OnInit
{
    public addItemForm: FormGroup;

    title: string;
    formConfig: AddItemData[];
    formValues: string[];

    quillEditor: any;
    quillModules: any = {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'link'],
                [{align: []}, {list: 'ordered'}, {list: 'bullet'}],                
                // ['image'],
                ['clean'],
            ],
            handlers: {
            'image': this.imageHandler.bind(this),
            'imageDropAndPaste': {
                    handler: this.imageHandler.bind(this)
                }
            }
        }
    };

    constructor(
        public dialogRef: MatDialogRef<AddItemDialogComponent>,
        protected _formBuilder: FormBuilder,
        protected cdr: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string,
            items: AddItemData[],
            buttons: AddButtonData[],
            allowPristineSave?: boolean,
            constrainHeight?: boolean
        })
    {}

    ngOnInit(): void
    {
        this.title = this.data.title;
        this.formConfig = this.data.items;

        //set tabs if applicable
        for(var configItem of this.formConfig.filter(x => x.hasTabs))
            configItem['selectedTab'] = 0;//this.getTabNames(config)[0];

        this.buildForm();
    }

    buildForm() {
        var group = {};

        this.formConfig.forEach(item => {
            console.log("building form item", item);
            var name = this.getFormControlName(item);
            group[name] = [item.initialValue ?? '', { updateOn: 'blur' }];
        });

        this.addItemForm = this._formBuilder.group(group);
        
        this.formConfig.filter(x => x.mandatory).forEach(item => this.addItemForm.controls[this.getFormControlName(item)].addValidators(Validators.required));
        
        this.cdr.detectChanges();
    }

    getFormControlName(item: AddItemData) {
        if(!item) return null;

        return item.propertyName ?? item.name;
    }

    updateCurrency(event: any, itemControl: FormGroup, controlName: string) {
        var value = parseFloat(
          event.target.value.replace("£", "").replace(",", "")
        );
    
        if (!value || isNaN(value)) value = 0;
    
        itemControl?.controls[controlName].setValue(value);
    }

    addToRadioMulti(value: any, controlName: string) {
        var radioItems = this.addItemForm.controls[controlName].value ?? [];
        radioItems.push(value);
        this.addItemForm.controls[controlName].setValue(radioItems);
        this.addItemForm.markAsDirty();
    }

    removeRadioMultiChip(index: any, controlName: string) {
        var radioItems = this.addItemForm.controls[controlName].value ?? [];
        radioItems = radioItems.filter((_, i) => i != index);
        
        this.addItemForm.controls[controlName].setValue(radioItems);
        this.addItemForm.markAsDirty();
    }

    getOptionName(options: EnumViewModelWithInfo[], value: number | string) {
        return options.find(x => x.value == value)?.name;
    }

    setIcon(icon: string, controlName: string) {
        this.addItemForm.controls[controlName].setValue(icon);
        this.addItemForm.markAsDirty();
    }
    
    save() {
        this.dialogRef.close(this.addItemForm.value);
    }

    close() {
        this.dialogRef.close(null);
    }

    onEditorCreated(quill) {
        this.quillEditor = quill;
    }

    imageHandler() {
        //prevent images being pasted in
    }

    doButtonCallback(button: AddButtonData) {
        button.callback();

        if(button.closeDialog)
            this.close();
    }

    anyOptionsHaveInfo = (configItem: AddItemData) => configItem.options?.filter(x => !!x.info).length > 0;

    getTabNames = (configItem: AddItemData) => configItem.options.map(x => x.tabName).filter((val, i, arr) => arr.indexOf(val) === i);

    isSelectedInRadioMulti(controlName: string, value: number) {
        var radioItems: number[] = this.addItemForm.controls[controlName].value ?? [];
        return radioItems.indexOf(value) > -1;
    }

    getRadioOptions(configItem: AddItemData) {
        if(!configItem.hasTabs)
            return configItem.options;

        var currentTab = this.getTabNames(configItem)[configItem['selectedTab']];
        
        return configItem.options.filter(x => x.tabName == currentTab);
    }

}
